import {MatrixCredentials} from '@/types/matrix';
import {
  ClientEvent,
  MatrixClient,
  SyncState,
  createClient
} from 'matrix-js-sdk';
import {MATRIX_SERVER_URL} from './constants';

export const startClientFromPersistedCredentials = async (
  credentials: MatrixCredentials
): Promise<MatrixClient> => {
  try {
    const client = createClient({
      baseUrl: MATRIX_SERVER_URL,
      accessToken: credentials.accessToken,
      userId: credentials.userId,
      deviceId: credentials.deviceId
    });

    await client.whoami();

    if (!client.getSyncState() || client.getSyncState() === SyncState.Stopped) {
      client.startClient({
        initialSyncLimit: 30
      });

      await new Promise<void>((resolve, reject) => {
        client.once(ClientEvent.Sync, (state) => {
          if (state === SyncState.Prepared) {
            resolve();
          } else {
            reject(new Error(`Unexpected sync result on prepare: "${state}"`));
          }
        });
      });
    }

    return client;
  } catch (error) {
    console.error(
      'Error during Matrix client initialization with persisted credentials:',
      error
    );
    throw error;
  }
};
